import React from 'react';
import { getMeetingsFromDynamoDB, getMeetingFromDynamoDBByID, findMeeting, parseMeeting } from './Api';
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Flashbar, Button, Link, Badge, Table,
  Header, Container, ContentLayout, AppLayout, SideNavigation, SpaceBetween, Box, TextContent, BreadcrumbGroup
} from '@cloudscape-design/components';
import { usePDF } from 'react-to-pdf';
import { useAuth } from './AuthContext';
import { NavigationSide } from './Navigation';



function MeetingDetails() {
  const { meetingId } = useParams();
  const [thisMeeting, setThisMeeting] = useState(null);
  const [fillerColor, setColor] = useState(null);
  const [weaselColor, setWeaselColor] = useState(null);
  const [wpmColor, setWpmColor] = useState(null);
  const [score, setScore] = useState(null);
  const [scoreColor, setScoreColor] = useState(null);
  const [msg, setMsg] = useState(null);
  const [done, setDone] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    async function fetchMeetingDetails() {
      if (loading) return;
      console.log("Calling effect");
      try {
        setLoading(true);
        const data = await getMeetingFromDynamoDBByID(meetingId);
        const meetingResult = parseMeeting(data);
        setLoading(false);
        setThisMeeting(meetingResult);
        if (meetingResult.wpm !== null) {
          setDone("Call successfully transcribed!");
        } else {
          setDone("Call transcription in progress");
        }
        console.log("data", meetingResult);
        setColor("green");
        if (meetingResult.filler >= 225 && meetingResult.filler < 300) {
          setColor("severity-medium");
        } else if (meetingResult.filler >= 300) {
          setColor("red");
        }

        setWeaselColor("green");
        if (meetingResult.weasel >= 225 && meetingResult.weasel < 300) {
          setWeaselColor("severity-medium");
        } else if (meetingResult.weasel >= 300) {
          setWeaselColor("red");
        }

        setWpmColor("green");
        if (meetingResult.wpm >= 170) {
          setWpmColor("red")
        }
        // const output = meetingResult.promptOutput.match("(?:[1-9][0-9]*|0)\/[1-9][0-9]*");
        const output = meetingResult.promptOutput.overall_score;
        // setScore(output !== null ? output[0] : 0);
        setScore(output);
        // const rawScore = eval(output !== null ? output[0] : 0);
        const rawScore = eval(output);
        console.log("score", rawScore)
        if (rawScore < 70) {
          setMsg("Practice more!");
          setScoreColor("red")
        } else if (rawScore <= 85) {
          setMsg("Keep practicing!");
          setScoreColor("severity-medium")
        } else {
          setMsg("Great job!");
          setScoreColor("green")
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching meeting details:", error);
        setError("Failed to load meeting details. Please try again later.");
        setLoading(false);
      }
    }

    fetchMeetingDetails();
  }, [meetingId]);

  const { toPDF, targetRef } = usePDF({ filename: meetingId + ".pdf" });

  return (thisMeeting && fillerColor && weaselColor &&wpmColor && scoreColor && msg &&
    <ContentLayout
      breadcrumbs={<BreadcrumbGroup
        items={[
          { text: "Home", href: "/" },
          { text: "Meetings", href: "/meetings" },
          { text: `${thisMeeting.callId}`, href: "#" },
        ]}
        ariaLabel="Breadcrumbs"
      />}
      header={
        <Header
          variant="h1"
          description={thisMeeting.callId}
        >
          Meeting Details
        </Header>
      }
      notifications={
        <Flashbar
          items={[
            {
              type: "success",
              content: `${done}`,
              dismissible: false,
              dismissLabel: "Dismiss message",
              id: "message_1",
            }
          ]}
        />
      }
    >
      <div ref={targetRef} style={{backgroundColor: '#161d26'}}>
        <SpaceBetween size="l">
          <SpaceBetween size="m" direction="horizontal">
            <Container
              header={
                <Header
                  variant="h2"
                  description="Information about your call."
                >
                  Call Details
                </Header>
              }>
              <Box variant="awsui-key-label">Call Info</Box>
              <Box color="text-body-secondary"><b>User ID: </b>{thisMeeting.userId}</Box>
              <Box color="text-body-secondary"><b>AWSome Builder: </b>{thisMeeting.promptOutput.type}</Box>
              <SpaceBetween size="xs">
                <Box color="text-body-secondary"><b>Call Name</b>: {thisMeeting.callId}</Box>
                <Box color="text-body-secondary"><Button onClick={() => toPDF()}>Download Call Report</Button></Box>
              </SpaceBetween>
            </Container>
            <Container
              fitHeight
              header={
                <Header
                  variant="h2"
                  description="Your meeting's metrics"
                >
                  Meeting Metrics
                </Header>
              }>
              <SpaceBetween size="m">
                <SpaceBetween direction="horizontal" size="xs">
                  <Badge color={wpmColor}>Words Per Minute: {parseInt(thisMeeting.wpm)}</Badge>
                  <Badge color={fillerColor}>Filler Words: {thisMeeting.filler}</Badge>
                  <Badge color={weaselColor}>Weasel Words: {thisMeeting.weasel}</Badge>
                </SpaceBetween>
                <Box variant='text-body-secondary'>Try to keep all metrics in the green!</Box>
              </SpaceBetween>
            </Container>
            <Container fitHeight
              header={
                <Header
                  variant="h2"
                  description="Your personalized call score"
                >
                  Call Score
                </Header>
              }>
              <SpaceBetween size="m">
                <Badge color={scoreColor}>Call Score: {score}</Badge>
                <Box variant='text-body-secondary'>Try to keep this metric in the green!</Box>
              </SpaceBetween>
            </Container>
          </SpaceBetween>

          <Container
            header={
              <Header
                variant="h2"
                description="An overview of your feedback from the AWS Eloquence agent"
              >
                Meeting Feedback
              </Header>
            }>
            <Box variant="p">
              {thisMeeting.promptOutput.messaging_feedback}
            </Box>
          </Container>
          <FeedbackContainer feedbackData={thisMeeting.promptOutput.feedback} />
        </SpaceBetween>
      </div>

    </ContentLayout>

  );
}

const FeedbackContainer = ({ feedbackData }) => {
  const getScoreColor = (score) => {
    switch (score) {
      case 'Yes':
        return 'green';
      case 'Needs Improvement':
        return 'orange';
      case 'No':
        return 'red';
      default:
        return 'inherit';
    }
  };

  return (
    <Container
      header={
        <Header
          variant="h2"
          description="Detailed feedback from the AWS Eloquence agent"
        >
          Rubric Feedback
        </Header>
      }
    >
      <Table
        columnDefinitions={[
          {
            id: 'question',
            header: 'Question',
            cell: item => item.question,
            width: 300
          },
          {
            id: 'score',
            header: 'Score',
            cell: item => (
              <Box color={getScoreColor(item.score)}>
                {item.score}
              </Box>
            ),
            width: 150
          },
          {
            id: 'feedback',
            header: 'Feedback',
            cell: item => item.feedback
          }
        ]}
        items={feedbackData}
        wrapLines
        stripedRows
      />
    </Container>
  );
};


function Old() {
  const { meetingId } = useParams();
  const [thisMeeting, setThisMeeting] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchMeetingDetails() {
      console.log("Calling effect");
      try {
        const data = await getMeetingsFromDynamoDB();
        setThisMeeting(findMeeting(data, meetingId));
        setLoading(false);
      } catch (error) {
        console.error("Error fetching meeting details:", error);
        setError("Failed to load meeting details. Please try again later.");
        setLoading(false);
      }
    }

    fetchMeetingDetails();
  }, [meetingId]);

  return (
    <>
      <BreadcrumbGroup
        items={[
          { text: "Home", href: "/" },
          { text: "My Meetings", href: "/meetings" },
          { text: "Meeting Details", href: "/meeting/:meetingId" },
        ]}
        ariaLabel="Breadcrumbs"
      />
      <ContentLayout
        header={
          <Header variant="h1">
            Meeting Details
          </Header>
        }
      >

        <Container>
          <Header variant="h2">Meeting ID: {meetingId}</Header>
          <SpaceBetween size="xl">
            {thisMeeting && (
              <Container>
                <SpaceBetween size="m">
                  <Header variant="h3">Prompt Output</Header>
                  <Box padding="s" backgroundColor="light">
                    <TextContent>
                      <pre style={{
                        whiteSpace: 'pre-wrap',
                        wordWrap: 'break-word',
                        maxWidth: '100%',
                        overflowX: 'auto'
                      }}>
                        {thisMeeting.promptOutput}
                      </pre>
                    </TextContent>
                  </Box>
                </SpaceBetween>
              </Container>
            )}
          </SpaceBetween>
        </Container>
      </ContentLayout>
    </>
  );
};

function App() {
  return (
    <AppLayout
      navigation={<NavigationSide />}
      content={
        <MeetingDetails />
      }
    />
  )
}

function Navigation() {
  return (
    <SideNavigation
      header={{ text: 'AWS Eloquence', href: '/' }}
      items={[
        { type: 'link', text: 'Learn More', href: '/learnmore' },
        { type: 'link', text: 'Get Started', href: '/getstarted' },
        { type: 'link', text: 'My Meetings', href: '/meetings' },
        { type: 'link', text: 'Meet the Team', href: '/meettheteam' },
        { type: 'link', text: 'Architecture Diagram', href: '/architecture' },
        { type: 'divider' },
        { type: 'link', text: 'Documentation', href: '/documentation' },
      ]}
    />
  );
}

export default App;
